export default function isValidComponent(target) {
	const component = target.closest('[component]');
	if (!component) return false;
	// Layout Komponenten ausschließen
	const componentNodename = component.nodeName.toLowerCase();
	return componentNodename.indexOf("layout-") === -1;
}
